import { date } from 'quasar'

export default {
  eventList,
}

function getEntityFromId(id) {
  switch (id) {
    case 1: return 'User'
    case 2: return 'Student'
    case 3: return 'Course'
    case 4: return 'Class'
    case 5: return 'Document'
    case 6: return 'Order'
    case 7: return 'Report'
    case 8: return 'Instructor'
    case 9: return 'Affiliate'
    case 10: return 'Recruiter'
    case 11: return 'Manager'
    case 12: return 'Administrator'
    case 13: return 'Credit'
  }
}

function eventList (state, getters, rootState) {
  return state.list.map(e => ({
    ...e,
    ENTITY_TYPE: getEntityFromId(e.LK_ENTITY_TYPE_ID),
    DATE_CREATED: date.formatDate(e.DATE_CREATED, rootState.shared.formats.datetime),
  }))
}
